
<ng-container *ngFor="let item of items">
    <div class="team-avatar d-flex justify-content-center" 
        [ngClass]="item?.alignment" 
        *ngIf="item?.type == 'IMAGE'" 
    >
        <img loading="lazy" [src]="item?.content" class="img-fluid" style="max-width: 340px;" />
    </div>

    <div [style.padding-top.px]="item?.padding"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'TEXT'"
    >
        <p class="font-size-18 mb-0" [ngClass]="item?.alignment"><strong>{{ item?.content }}</strong></p>
    </div>

    <div class="d-block mx-auto font-size-16"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'TEXTAREA'" 
    >
        <p [ngClass]="item?.alignment" class="font-size-16">{{ item?.content }}</p>
    </div>
</ng-container>
